import { Brand } from 'src/app/components/company/models/new/brand.model';
import { Category } from './category';
import { StyleGroup } from './style-group';
import { StyleDescription } from './style-description';
import { Collection } from './collection';
import { Purpose } from './purpose';
import { Team } from './team';
import { PaginationFilters } from './paginationFilters';
import { Status } from './status';
import { Gender } from './style';
import { Order } from './order';
import { DateRange } from './dateRange';

export class PriceChange {
  orderId?: number;
  orderCreationDate?: Date;
  price?: number;

  constructor(init?: Partial<PriceChange>) {
    Object.assign(this, init);
  }
}

export class StylePrice {
  brand?: Brand;
  category?: Category;
  modelId?: number;
  code?: string;
  name?: string;
  styleGroup?: StyleGroup;
  styleDescription?: StyleDescription;
  gender?: Gender;
  orders?: Order[];
  periodAverage?: number;
  priceChanges?: PriceChange[];

  constructor(init?: Partial<StylePrice>) {
    Object.assign(this, init);
  }
}

export class StylePriceFilters extends PaginationFilters {
  brands?: Brand[];
  categories?: Category[];
  styleGroups?: StyleGroup[];
  styleCode?: string;
  styleDescriptions?: StyleDescription[];
  collections?: Collection[];
  purposes?: Purpose[];
  genders?: Gender[];
  statuses?: Status[];
  teams?: Team[];
  dateRange?: DateRange;

  constructor(init?: Partial<StylePriceFilters>) {
    super(init);
    Object.assign(this, init);
  }
}
